export const tableDetailsConfig = {
    clearLineAnalysisMsg: "Line analysis cleared successfully"
};